import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        RECEIPT: 'RECEIPT',
        SALES_RECEIPT: 'SALES_RECEIPT',
        OTHER: 'OTHER',
      },
    }
  }
}